import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { faTrash, faEdit, faFileDownload, faPaperclip, faArrowCircleUp  } from '@fortawesome/free-solid-svg-icons';
import { TableKeys } from 'src/app/models/table'
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'ng-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @ViewChild('confirmModal', { static: false }) confirmModal: ModalDirective;

  private _tableRows?: Array<object>;

  get tableRows(): Array<object> {
    return this._tableRows;
  }

  @Input() set tableRows(rows: Array<object>) {
    this._tableRows = rows;
    this.filteredTableRows = rows;
    this.setDisplayCount(rows);
  }

  @Input() tableKeys: Array<TableKeys>;
  @Input() isUpdateEnabled: boolean;
  @Input() isFileDownload: boolean;
  @Input() isRowReplace: boolean;
  @Output() selectRowEvent = new EventEmitter<object>();
  @Output() deleteRowEvent = new EventEmitter<object>();
  @Output() updateRowEvent = new EventEmitter<object>();
  @Output() downloadRowEvent = new EventEmitter<object>();
  @Output() replaceRowEvent = new EventEmitter<object>();

  public readonly faTrash = faTrash;
  public readonly faEdit = faEdit;
  public readonly faFileDownload = faFileDownload;
  public readonly faArrowCircleUp = faArrowCircleUp;
  public readonly displayCount = 10;

  public filteredTableRows?: Array<object>;
  public searchQuery: string = "";
  public currentPage = 0;
  public totalPages?: number;
  public pagination?: Array<number>;

  public rowToDelete?: object;

  constructor() { }

  ngOnInit(): void {}

  /**
   * Filter table rows by search query
   */
  submitSearch(): void {
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.filteredTableRows = this.filterRows(this.tableRows, this.searchQuery);
    } else {
      this.filteredTableRows = this.tableRows;
    }

    this.setDisplayCount(this.filteredTableRows);
  }

  /**
   * Compares search query against each table item, returning rows with matching values
   * @param rows 
   * @param searchQuery 
   */
  filterRows(rows: Array<object>, searchQuery: string): Array<object> {
    if (!rows || rows == null) {
      return rows;
    }

    if (!rows) return []
    if (!searchQuery) return rows

    let formattedQuery = searchQuery.toLowerCase()
    let filteredRows = []

    for (let i = 0, r = rows.length; i < r; i++) {
      let currentRow = rows[i]
      let keys = Object.keys(currentRow)
      let keysIndex = 0
      let found = false

      while (!found && keysIndex < keys.length) {
        let key = keys[keysIndex]
        let val = currentRow[key]

        if (val && val !== Object(val)) {
          if (isNaN(val)) {
            if ((val as string).toLowerCase().includes(formattedQuery)) {
              filteredRows.push(currentRow)
              found = true
            }
          } else {
            if ((val as number).toString().includes(formattedQuery)) {
              filteredRows.push(currentRow)
              found = true
            }
          }
        }
        keysIndex++
      }
    }

    return filteredRows
  }

  /**
   * Calculates pagination requirements based on tableRows passed as argument
   * @param tableRows 
   */
  setDisplayCount(tableRows: Array<object>): void {
    if (!tableRows) return;

    this.totalPages = Math.ceil(tableRows.length / this.displayCount);
    // Hack required to to allow for looping over total pages for pagination.
    let pagination: Array<number> = new Array<number>();
    for (let i = 0; i < this.totalPages; i++) {
      pagination.push(i);      
    }
    this.pagination = pagination;
  
    // If the user is on a page that no longer exists, move them back a page.
    if (this.currentPage === this.totalPages) {
      this.currentPage = this.totalPages - 1;
    }

    this.currentPage = 0;
  }

  setCurrentPage(nextPage: number): void {
    if (nextPage <= this.totalPages && nextPage >= 0) {
      this.currentPage = nextPage;
    }
  }

  selectRow(row: object): void {
    this.selectRowEvent.emit(row);
  }

  deleteRow(row: object) {
    this.deleteRowEvent.emit(row);
  }

  updateRow(row: object) {
    this.updateRowEvent.emit(row);
  }

  downloadRow(row: object) {
    this.downloadRowEvent.emit(row);
  }

  replaceRow(row: object) {
    this.replaceRowEvent.emit(row);
  }

  showConfirmModal(row: object) {
    this.rowToDelete = row;
    if (confirm('Are you sure you want to delete?')){
        this.deleteRow(row);
    }
  }

  hideConfirmModal() {
    this.confirmModal.hide();
  }
}
